// The unit a cs-progress-chart series is drawn in (df-f7b9355bc5a3). The chart reads both answers
// from the shared measurement config, the same one the rest of the app formats values with, so a
// new measurement type or unit needs no change here.

import { LocaleSettings } from '@cf-shared/shared-util';
import { getMeasureUnitConversion } from 'util/formatting';

/** what multiplies a canonical value into the shown unit, and that unit's name (none for a series with no measurement type) */
export interface SeriesUnit {
  factor: number;
  unitName?: string;
}

/**
 * the unit one series is shown in.
 * the series' own unit wins (the exercise chart's per-exercise unit), then the person's stored
 * preference for the type, then the default for their region, as everywhere else in the app.
 */
export function seriesUnit(
  measurementTypeId: string | undefined,
  displayUnit: string | undefined,
  locale: LocaleSettings,
  storedUnitPref: (measurementTypeId: string) => string | undefined,
): SeriesUnit {
  // if the series has no measurement type, its values are drawn as they come
  if (!measurementTypeId) return { factor: 1 };
  return getMeasureUnitConversion(measurementTypeId, locale, displayUnit ?? storedUnitPref(measurementTypeId));
}
